var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate2Web = function SvgTemplate2Web(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.66667 6.66797H5.33333C4.59695 6.66797 4 7.26492 4 8.0013V13.3346C4 14.071 4.59695 14.668 5.33333 14.668H6.66667C7.40305 14.668 8 14.071 8 13.3346V8.0013C8 7.26492 7.40305 6.66797 6.66667 6.66797Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.3334 6.66797H12.0001C11.2637 6.66797 10.6667 7.26492 10.6667 8.0013V13.3346C10.6667 14.071 11.2637 14.668 12.0001 14.668H13.3334C14.0698 14.668 14.6667 14.071 14.6667 13.3346V8.0013C14.6667 7.26492 14.0698 6.66797 13.3334 6.66797Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.9999 6.66797H18.6666C17.9302 6.66797 17.3333 7.26492 17.3333 8.0013V13.3346C17.3333 14.071 17.9302 14.668 18.6666 14.668H19.9999C20.7363 14.668 21.3333 14.071 21.3333 13.3346V8.0013C21.3333 7.26492 20.7363 6.66797 19.9999 6.66797Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6667 6.66797H25.3333C24.597 6.66797 24 7.26492 24 8.0013V13.3346C24 14.071 24.597 14.668 25.3333 14.668H26.6667C27.403 14.668 28 14.071 28 13.3346V8.0013C28 7.26492 27.403 6.66797 26.6667 6.66797Z",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.66667 17.332H5.33333C4.59695 17.332 4 17.929 4 18.6654V23.9987C4 24.7351 4.59695 25.332 5.33333 25.332H6.66667C7.40305 25.332 8 24.7351 8 23.9987V18.6654C8 17.929 7.40305 17.332 6.66667 17.332Z",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.3334 17.332H12.0001C11.2637 17.332 10.6667 17.929 10.6667 18.6654V23.9987C10.6667 24.7351 11.2637 25.332 12.0001 25.332H13.3334C14.0698 25.332 14.6667 24.7351 14.6667 23.9987V18.6654C14.6667 17.929 14.0698 17.332 13.3334 17.332Z",
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.9999 17.332H18.6666C17.9302 17.332 17.3333 17.929 17.3333 18.6654V23.9987C17.3333 24.7351 17.9302 25.332 18.6666 25.332H19.9999C20.7363 25.332 21.3333 24.7351 21.3333 23.9987V18.6654C21.3333 17.929 20.7363 17.332 19.9999 17.332Z",
    stroke: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6667 17.332H25.3333C24.597 17.332 24 17.929 24 18.6654V23.9987C24 24.7351 24.597 25.332 25.3333 25.332H26.6667C27.403 25.332 28 24.7351 28 23.9987V18.6654C28 17.929 27.403 17.332 26.6667 17.332Z",
    stroke: "currentColor"
  })));
};
export default SvgTemplate2Web;